import { IStaffRealtime } from 'models/Map';
import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';

type initialStateType = {
  realtimeStaffData: Array<IStaffRealtime>;
  realtimeStaffMarkerData: [];
};

const initialState: initialStateType = {
  realtimeStaffData: [
    {
      address: '366/16C LVQ',
      completeTask: 10,
      extensionNumber: '111',
      inProcessTask: 2,
      movingDistance: 111,
      name: 'Nguyễn Văn A',
      phone: '0909123456',
      plate: '50N-00009',
      updateTime: '2023-12-25T09:00:51.480Z'
    },
    {
      address: '340/16 LVQ',
      completeTask: 10,
      extensionNumber: '111',
      inProcessTask: 2,
      movingDistance: 111,
      name: 'Nguyễn Văn B',
      phone: '0909123456',
      plate: '50N-00010',
      updateTime: '2023-12-25T09:00:51.480Z'
    },
    {
      address: '340/16 LVQ',
      completeTask: 10,
      extensionNumber: '111',
      inProcessTask: 2,
      movingDistance: 111,
      name: 'Nguyễn Văn C',
      phone: '0909123456',
      plate: '50N-00011',
      updateTime: '2023-12-25T09:00:51.480Z'
    }
  ],
  realtimeStaffMarkerData: []
};

const operatingSlide = createSlice({
  name: 'operating',
  initialState: initialState,
  reducers: {
    resetState: state => {
      state.realtimeStaffData = [];
    },
    slide: state => {
      state.realtimeStaffData = [];
    }
  }
});

export const { resetState } = operatingSlide.actions;

export default operatingSlide.reducer;
